/* ==========================================================================
   WAIFU LEWD VAULT — assets/wlv-vault.js
   No dependencies. jQuery and Slick are gone.

   Reads window.WLV, bootstrapped by templates/page.wlv.liquid.
   Every rail, result and card is client rendered from the same lean index,
   which arrives asynchronously from the page.wlv-idxN templates.

   Download gating here is presentational. See the note at the top of the
   template. Guests and non-members never receive a file URL; members do.
   ========================================================================== */
(function () {
  "use strict";

  /* Belt and braces: the template releases the theme overlay in its own inline
     script. Repeat it here so the page is never left black if that is edited
     out by mistake. */
  try {
    document.body.classList.remove("show-overlay", "overlay-fade-out");
    document.body.classList.add("wlv-active");
  } catch (e) {}

  var W = window.WLV;
  var root = document.getElementById("wlv-page");
  if (!W || !root || root.getAttribute("data-wlv-init")) return;
  root.setAttribute("data-wlv-init", "1");

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function motion() { return reduced ? "auto" : "smooth"; }

  /* Hoisted out of the video block so cardHTML and openItem can ask the same
     question the observer does. On reduced-motion or a metered/2G connection
     no <video> is emitted at all — not a paused one — so nothing is fetched
     and the card renders exactly as it did before video existed. */
  var vconn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var slow = !!(vconn && (vconn.saveData === true || /(^|-)2g$/.test(vconn.effectiveType || "")));
  function liteMedia() { return reduced || slow; }

  var PAGE = 24;
  var S = { view: "browse", q: "", series: "", chr: "", outfit: "", type: "", sort: "new", page: 1, row: "", rowFilter: "" };
  var PLAN = "monthly";

  /* ------------------------------------------------------------------ *
   * 0. Utilities
   * ------------------------------------------------------------------ */
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  /* Look the item up in the client index first. If the index is disabled or
     truncated, fall back to the data attributes on the server-rendered card,
     so rails, previews and downloads keep working regardless. */
  function byId(id) {
    for (var i = 0; i < W.index.length; i++) if (W.index[i].i === id) return W.index[i];
    var el = document.querySelector('.wlv-card[data-id="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]');
    if (!el) return null;
    var d = el.dataset;
    return {
      i: id, n: d.n || "", a: d.a || "", t: d.t || "",
      o: d.o ? d.o.split(/,\s*/) : [], c: [], h: d.h || "", s: [], d: 0, p: 0,
      f: d.f || ""
    };
  }
  function canDownload() { return W.state === "member"; }

  /* Unix seconds -> a readable date. Empty when the entry has no timestamp. */
  function fmtDate(secs) {
    var n = Number(secs || 0);
    if (!n) return "";
    try {
      return new Date(n * 1000).toLocaleDateString(undefined,
        { year: "numeric", month: "short", day: "numeric" });
    } catch (e) { return ""; }
  }

  /* Display labels for stored values that are misspelled in the metaobject
     data. Keys are what is stored, values are what the customer sees.
     Filtering still matches on the stored value, so fixing the data later
     costs nothing — just delete the entry from this map. */
  var LABELS = { "Annimated Wallpaper Combo": "Animated Wallpaper Combo" };
  function label(v) { return LABELS[v] || v; }

  /* What each product type contains, shown as pills in the item modal.
     Keys must match the STORED type string exactly, including the double-N
     misspelling of "Annimated" that the metaobject data uses. LABELS above
     fixes the spelling for display; this map must not.

     A type absent from this map renders no pill row and the container stays
     hidden, which is how "SFW Wallpaper" is handled. */
  var PILLS = {
    "Image Combo":               ["2 Images", "1 SFW", "1 NSFW", "Full HD", "Full Size", "Phone Cut"],
    "Animation":                 ["1 Animation", "SFW or NSFW", "Full HD", "Full Size", "Phone Cut"],
    "Animation Combo":           ["2 Animations", "1 SFW", "1 NSFW", "Standard Size", "Full HD"],
    "Annimated Wallpaper Combo": ["2 Animations", "1 SFW", "1 NSFW", "Phone Cut", "Full HD", "Seamless Loop"]
  };

  function track(evt, data) {
    data = data || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: "wlv_" + evt }, data));
      if (typeof window.gtag === "function") window.gtag("event", "wlv_" + evt, data);
      if (typeof window.fbq === "function") window.fbq("trackCustom", "wlv_" + evt, data);
    } catch (e) { /* analytics must never break the page */ }
  }

  function toast(msg) {
    var t = $("#wlv-toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("is-on");
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove("is-on"); }, 2800);
  }

  /* ------------------------------------------------------------------ *
   * 1. Search — normalisation plus bounded typo tolerance
   * ------------------------------------------------------------------ */
  function norm(s) { return String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim(); }
  function squash(s) { return norm(s).replace(/\s+/g, ""); }

  function lev(a, b, max) {
    if (a === b) return 0;
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur[0] = i;
      var best = cur[0];
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1,
          prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      prev = cur.slice();
    }
    return prev[b.length];
  }

  /* Short words must be near exact, long words get more slack. */
  function tol(len) { return len <= 3 ? 0 : len <= 5 ? 1 : 2; }

  function hay(it) {
    if (it._h) return it._h;
    it._h = norm([it.n, it.a, it.t, (it.o || []).join(" "), (it.c || []).join(" ")].join(" "));
    it._hs = it._h.replace(/\s+/g, "");
    it._w = it._h.split(" ");
    return it._h;
  }

  function score(it, toks, sq) {
    hay(it);
    var total = 0;
    for (var t = 0; t < toks.length; t++) {
      var q = toks[t], best = 0;
      if (it._hs.indexOf(q) === 0) best = 100;
      else if (it._h.indexOf(" " + q) > -1 || it._h.indexOf(q) === 0) best = 88;
      else if (it._hs.indexOf(q) > -1) best = 64;
      else {
        for (var w = 0; w < it._w.length; w++) {
          var word = it._w[w];
          if (!word) continue;
          if (word.indexOf(q) === 0) { best = Math.max(best, 80); continue; }
          var d = lev(q, word, tol(q.length));
          if (d <= tol(q.length)) best = Math.max(best, 58 - d * 12);
        }
      }
      if (best === 0) return 0;   /* every token must match something */
      total += best;
    }
    if (sq && it._hs.indexOf(sq) > -1) total += 25;
    return total / toks.length;
  }

  function runSearch(list, q) {
    var nq = norm(q);
    if (!nq) return list.slice();
    var toks = nq.split(" ").filter(Boolean), sq = squash(q), out = [];
    for (var i = 0; i < list.length; i++) {
      var sc = score(list[i], toks, sq);
      if (sc > 0) out.push({ it: list[i], sc: sc });
    }
    out.sort(function (a, b) { return b.sc - a.sc; });
    return out.map(function (o) { return o.it; });
  }

  /* ------------------------------------------------------------------ *
   * 2. Filtering
   * ------------------------------------------------------------------ */
  function activeFilters() {
    var a = [];
    if (S.type) a.push({ k: "type", v: S.type });
    if (S.series) a.push({ k: "series", v: S.series });
    if (S.chr) a.push({ k: "chr", v: S.chr });
    if (S.outfit) a.push({ k: "outfit", v: S.outfit });
    if (S.rowFilter) a.push({ k: "row", v: S.row });
    return a;
  }
  function isFiltering() { return S.q !== "" || activeFilters().length > 0; }

  function matchesRow(i) {
    var f = S.rowFilter || "";
    if (!f) return true;
    var k = f.slice(0, f.indexOf(":")), v = f.slice(f.indexOf(":") + 1).toLowerCase();
    if (k === "cat") {
      return (i.c || []).some(function (c) { return String(c).toLowerCase() === v; });
    }
    if (k === "type") return String(i.t).toLowerCase() === v;
    if (k === "typestarts") return String(i.t).toLowerCase().indexOf(v) === 0;
    return true;
  }

  function filtered() {
    var list = W.index;
    if (S.rowFilter) {
      var rp = ruleParts(S.rowFilter);
      /* recent and popular are orderings, not filters — expand to 200 here
         so "See all" shows meaningfully more than the 20 on the rail. */
      if (rp.k === "recent" || rp.k === "popular") list = pick(S.rowFilter, 200);
      else list = list.filter(matchesRow);
    }
    if (S.type) list = list.filter(function (i) { return i.t === S.type; });
    if (S.series) list = list.filter(function (i) { return i.a === S.series; });
    if (S.chr) list = list.filter(function (i) { return i.n === S.chr; });
    if (S.outfit) list = list.filter(function (i) { return (i.o || []).indexOf(S.outfit) > -1; });
    list = runSearch(list, S.q);
    var rk = ruleParts(S.rowFilter).k;
    if (!S.q && rk !== "recent" && rk !== "popular") {
      list = list.slice();
      if (S.sort === "popular" && !hasPopularity(list)) S.sort = "new";
      if (S.sort === "new") list = byRecent(list);
      else if (S.sort === "popular") list.sort(function (a, b) { return (b.p || 0) - (a.p || 0); });
      else if (S.sort === "az") list.sort(function (a, b) { return String(a.n).localeCompare(String(b.n)); });
    }
    return list;
  }

  /* ------------------------------------------------------------------ *
   * 3. Card rendering — mirrors snippets/wlv-card.liquid
   * ------------------------------------------------------------------ */
  function ctaHTML(it) {
    if (canDownload())
      return '<button type="button" class="wlv-btn wlv-btn--sm wlv-btn--block" data-dl="' + esc(it.i) + '">Download</button>';
    if (W.state === "paused")
      return '<button type="button" class="wlv-btn wlv-btn--sm wlv-btn--block wlv-btn--ghost" data-paused="1">Downloads paused</button>';
    return '<button type="button" class="wlv-btn wlv-btn--sm wlv-btn--block wlv-btn--lock" data-join>Join to download</button>';
  }

  /* withVideo is opt-in and checked with === true on purpose. Every caller
     reaches this through Array.map, which passes the array INDEX as the second
     argument — `items.map(cardHTML)` would otherwise switch video on for every
     card except the first. Only the featured rail passes it explicitly.

     `h` is always an image: wlv-item-json falls back to the first small
     thumbnail for video entries. So the <img> is the poster and the <video>
     layers over it. .wlv-thumb video only reaches opacity 1 once it is really
     playing, which is why a clip that stalls, 404s or will not decode leaves
     the artwork on screen instead of a black box. No poster attribute — the
     <img> already is one, and setting both downloads it twice. */
  function cardHTML(it, withVideo) {
    var thumb = it.h || (it.s && it.s[0]) || "";
    var outfit = (it.o && it.o[0]) || "Various";
    var vid = (withVideo === true && it.v && !liteMedia()) ? it.v : "";
    return '<article class="wlv-card" data-id="' + esc(it.i) + '">' +
      '<button type="button" class="wlv-thumb-btn" data-open="' + esc(it.i) + '"' +
        ' aria-label="Preview ' + esc(it.n) + ', ' + esc(label(it.t)) + ' from ' + esc(it.a) + '">' +
        '<div class="wlv-thumb">' +
          (thumb
            ? '<img src="' + esc(thumb) + '" alt="' + esc(it.n) + ' — ' + esc(label(it.t)) + '" width="400" height="533" loading="lazy" decoding="async">'
            : "") +
          (vid
            ? '<video src="' + esc(vid) + '" preload="none" muted loop playsinline webkit-playsinline disableremoteplayback aria-hidden="true" tabindex="-1"></video>'
            : "") +
          '<div class="wlv-badges"><span class="wlv-pill">' + esc(label(it.t)) + "</span></div>" +
          '<span class="wlv-wm" aria-hidden="true">Preview</span>' +
          (canDownload() ? "" : '<span class="wlv-memtag">&#128274; Members</span>') +
        "</div>" +
      "</button>" +
      '<div class="wlv-card-b">' +
        '<h3 class="wlv-card-t">' + esc(it.n) + "</h3>" +
        '<p class="wlv-card-s">' + esc(it.a) + " &bull; " + esc(outfit) + "</p>" +
      "</div>" +
      '<div class="wlv-card-f">' + ctaHTML(it) + "</div>" +
    "</article>";
  }

  /* ------------------------------------------------------------------ *
   * 4. Views
   * ------------------------------------------------------------------ */
  function setView(v) {
    S.view = v;
    var f = isFiltering();
    $("#wlv-browse").hidden = v !== "browse" || f;
    $("#wlv-results").hidden = v !== "browse" || !f;
    $("#wlv-vault").hidden = v !== "vault";
    var hero = $("#wlv-hero");
    if (hero) hero.hidden = v !== "browse" || f;
    $$("[data-view]").forEach(function (b) {
      b.setAttribute("aria-current", String(b.getAttribute("data-view") === v));
    });
    if (v === "vault") renderVault();
    if (v === "browse" && f) renderResults();
  }

  function renderResults() {
    var list = filtered(), n = list.length;
    var shown = list.slice(0, S.page * PAGE);
    $("#wlv-results-grid").innerHTML = shown.map(cardHTML).join("");
    $("#wlv-result-count").textContent =
      n === 0 ? "No matches" : n + " item" + (n === 1 ? "" : "s") + (S.q ? ' for "' + S.q + '"' : "");
    $("#wlv-results-h").textContent = S.row ? S.row : (S.q ? "Search results" : "Filtered");
    $("#wlv-more").hidden = shown.length >= n;

    var e = $("#wlv-results-empty");
    if (n === 0) {
      e.hidden = false;
      e.innerHTML =
        (W.index.length === 0
          ? '<p style="font-weight:700;color:#fff;margin-bottom:6px">Search is not available yet.</p>' +
            "<p>The search index is switched off in the template config. Browse the rows instead.</p>"
          : '<p style="font-weight:700;color:#fff;margin-bottom:6px">Nothing matched that.</p>' +
            "<p>Try a character name, a series, or an outfit.</p>") +
        '<p style="margin-top:14px"><button type="button" class="wlv-btn wlv-btn--ghost wlv-btn--sm" data-reset>Clear everything</button></p>';
    } else e.hidden = true;

    var ar = $("#wlv-active"), af = activeFilters();
    if (af.length || S.q) {
      ar.hidden = false;
      ar.innerHTML =
        (S.q ? '<span class="wlv-tag">Search: ' + esc(S.q) + '<button type="button" data-clear="q" aria-label="Clear search term">&times;</button></span>' : "") +
        af.map(function (x) {
          return '<span class="wlv-tag">' + esc(label(x.v)) + '<button type="button" data-clear="' + x.k + '" aria-label="Remove filter ' + esc(label(x.v)) + '">&times;</button></span>';
        }).join("") +
        '<button type="button" class="wlv-link" data-reset>Reset all</button>';
    } else ar.hidden = true;

    var cnt = af.filter(function (x) { return x.k !== "row"; }).length;
    $("#wlv-filters-n").hidden = !cnt;
    $("#wlv-filters-n").textContent = cnt;
  }

  /* ------------------------------------------------------------------ *
   * 5. My Vault — download history
   * NOTE: localStorage only. Writing customer metafields needs a server
   * endpoint, which this build does not have. History is per device and is
   * lost if the customer clears site data. Re-add a webhook to persist it.
   * ------------------------------------------------------------------ */
  var history = [];
  try { history = JSON.parse(localStorage.getItem("wlv_dl") || "[]"); } catch (e) { history = []; }

  function remember(id) {
    var i = history.indexOf(id);
    if (i > -1) history.splice(i, 1);
    history.unshift(id);
    history = history.slice(0, 200);
    try { localStorage.setItem("wlv_dl", JSON.stringify(history)); } catch (e) {}
  }

  function renderVault() {
    var items = history.map(byId).filter(Boolean);
    $("#wlv-vault-grid").innerHTML = items.map(cardHTML).join("");
    $("#wlv-vault-count").textContent = items.length ? items.length + " download" + (items.length === 1 ? "" : "s") : "";
    var e = $("#wlv-vault-empty");
    if (!items.length) {
      e.hidden = false;
      e.innerHTML = canDownload()
        ? '<p style="font-weight:700;color:#fff;margin-bottom:6px">Nothing downloaded yet.</p><p>Everything you download shows up here.</p><p style="margin-top:14px"><button type="button" class="wlv-btn wlv-btn--sm wlv-btn--ghost" data-view="browse">Browse the vault</button></p>'
        : '<p style="font-weight:700;color:#fff;margin-bottom:6px">Members only.</p><p>Your download history appears here once you join.</p><p style="margin-top:14px"><button type="button" class="wlv-btn wlv-btn--sm" data-join>Start membership</button></p>';
    } else e.hidden = true;
  }

  /* ------------------------------------------------------------------ *
   * 6. Modal — focus trap, Esc, focus restore
   * ------------------------------------------------------------------ */
  var lastFocus = null, openEl = null;

  function openModal(el) {
    vidHold = true;
    pumpVideos();
    lastFocus = document.activeElement;
    el.hidden = false;
    openEl = el;
    document.body.style.overflow = "hidden";
    var f = el.querySelector("button,select,a[href],input");
    if (f) f.focus();
  }
  function closeModal() {
    if (!openEl) return;
    var m = $("#wlv-m-media");
    /* Lift the hold first, so releaseVideos' pump restarts the rail tiles that
       were paused behind the overlay. */
    vidHold = false;
    /* Pause and unobserve before the node is discarded, otherwise the detached
       <video> stays in the observer and in the concurrency list forever. */
    if (m) { releaseVideos(m); m.innerHTML = ""; }
    else pumpVideos();
    openEl.hidden = true;
    openEl = null;
    document.body.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener("keydown", function (e) {
    if (!openEl) return;
    if (e.key === "Escape") { e.preventDefault(); closeModal(); return; }
    if (e.key !== "Tab") return;
    var f = $$('button,select,a[href],input,[tabindex]:not([tabindex="-1"])', openEl)
      .filter(function (n) { return n.offsetParent !== null && !n.disabled; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function openItem(id) {
    var it = byId(id);
    if (!it) return;
    var thumb = it.h || (it.s && it.s[0]) || "";
    /* Unlike the rails, the modal plays video for ANY animation entry, not
       just the featured five — it is one element at a time and it is the thing
       the visitor deliberately asked to look at, so preload is worth it here.
       No controls: these are silent art loops, and a control bar would change
       the modal's design. */
    var mvid = (it.v && !liteMedia()) ? it.v : "";
    var mediaEl = $("#wlv-m-media");
    mediaEl.innerHTML = (thumb
      ? '<img src="' + esc(thumb) + '" alt="' + esc(it.n) + ' — ' + esc(it.t) + '">'
      : "") + (mvid
      ? '<video src="' + esc(mvid) + '" preload="auto" autoplay muted loop playsinline webkit-playsinline disableremoteplayback aria-hidden="true" tabindex="-1"></video>'
      : "") + '<span class="wlv-wm" aria-hidden="true">Preview</span>';
    initVideos(mediaEl);
    $("#wlv-m-type").textContent = label(it.t);
    $("#wlv-m-title").textContent = it.n;
    $("#wlv-m-sub").textContent = it.a + " \u2022 " + (it.o || []).join(", ");

    var spec = PILLS[it.t] || null;
    var pillHost = $("#wlv-m-pills");
    if (pillHost) {
      pillHost.hidden = !spec;
      pillHost.innerHTML = spec
        ? spec.map(function (p) { return '<span class="wlv-spec-p">' + esc(p) + "</span>"; }).join("")
        : "";
    }
    $("#wlv-m-meta").innerHTML = [
      ["Series", it.a], ["Character", it.n],
      ["Outfit", (it.o || []).join(", ") || "Various"], ["Type", label(it.t)],
      ["Added", fmtDate(it.cr)]
    ].filter(function (r) { return r[1]; }).map(function (r) {
      return "<li><span>" + esc(r[0]) + "</span><span>" + esc(r[1]) + "</span></li>";
    }).join("");

    $("#wlv-m-cta").innerHTML = canDownload()
      ? '<button type="button" class="wlv-btn wlv-btn--block" data-dl="' + esc(it.i) + '">Download</button>'
      : (W.state === "paused"
        ? '<button type="button" class="wlv-btn wlv-btn--block wlv-btn--ghost" disabled>Downloads paused</button>'
        : '<button type="button" class="wlv-btn wlv-btn--block" data-join>Join to download &mdash; ' + esc(W.price.monthly) + "/mo</button>");

    $("#wlv-m-note").textContent = canDownload()
      ? "Full resolution. Unlimited downloads while your membership is active."
      : (W.state === "paused"
        ? "Your membership is on hold. You can browse everything, and downloads come back as soon as billing resumes."
        : "Preview is watermarked. Members download the full-resolution file.");

    openModal($("#wlv-item-modal"));
    track("preview_open", { id: it.i, type: it.t, series: it.a });
  }

  /* ------------------------------------------------------------------ *
   * 7. Download
   * ------------------------------------------------------------------ */
  function download(id) {
    if (!canDownload()) { toast("Membership required."); return; }
    var it = byId(id);
    var url = it && it.f;
    if (!url) { toast("That file link is missing. Please report it."); return; }
    remember(id);
    track("download", { id: id, type: it.t, series: it.a });
    var a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", "");
    a.target = "_blank";
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  /* ------------------------------------------------------------------ *
   * 8. Checkout
   * ------------------------------------------------------------------ */
  function join() {
    track("subscribe_started", { plan: PLAN });
    if (W.state === "guest") { window.location.href = W.loginUrl; return; }
    var vid = String(W.variantId || ""), plan = String(W.plans[PLAN] || "");
    if (!vid || vid.indexOf("0000000") === 0 || !plan || plan.indexOf("0000000") === 0) {
      toast("Membership product is not configured yet.");
      return;
    }
    toast("Opening checkout\u2026");
    fetch("/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } })
      .then(function () {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1, selling_plan: plan }] })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        window.location.href = "/checkout";
      })
      .catch(function () { toast("Could not start checkout. Please try again."); });
  }

  /* ------------------------------------------------------------------ *
   * 9. Rails
   * ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------ *
   * 9a. Rails, built in the browser from the index
   * The page ships no metaobject-rendered cards at all. Everything below
   * the hero is assembled from the JSON slices once they land.
   * ------------------------------------------------------------------ */
  /* Recency. Prefers the metaobject's own date field (cr = created_at,
     up = updated_at, both unix seconds, maintained by Flow). Falls back to
     system.id for any entry whose date is still empty, so a partial backfill
     still sorts sensibly instead of dumping undated entries at the bottom.
     Decided once per index load. */
  var RECENCY_KEY = null;
  function recencyKey() {
    if (RECENCY_KEY) return RECENCY_KEY;
    var pref = W.recencyField === "updated" ? "up" : "cr";
    var list = W.index, dated = 0, i;
    for (i = 0; i < list.length; i++) if (Number(list[i][pref]) > 0) dated++;
    if (dated) {
      RECENCY_KEY = pref;
      console.info("[WLV] Newest-first by " + (pref === "cr" ? "created_at" : "updated_at") +
        " (" + dated + " of " + list.length + " entries dated" +
        (dated < list.length ? "; the rest fall back to id" : "") + ")");
    } else {
      RECENCY_KEY = "i";
      console.warn("[WLV] No " + (pref === "cr" ? "created_at" : "updated_at") +
        " values came through. Falling back to system.id. Check the field key in wlv-item-json.");
    }
    return RECENCY_KEY;
  }

  function byRecent(list) {
    var k = recencyKey(), out = list.slice();
    if (k === "i") {
      out.sort(function (a, b) { return Number(b.i || 0) - Number(a.i || 0); });
      return out;
    }
    /* Undated entries sort by id among themselves, below everything dated. */
    out.sort(function (a, b) {
      var av = Number(a[k] || 0), bv = Number(b[k] || 0);
      if (av && bv) return bv - av;
      if (av) return -1;
      if (bv) return 1;
      return Number(b.i || 0) - Number(a.i || 0);
    });
    return out;
  }

  function byPopular(list) {
    var out = list.slice();
    out.sort(function (a, b) { return (b.p || 0) - (a.p || 0); });
    return out;
  }
  function hasPopularity(list) {
    for (var i = 0; i < list.length; i++) if ((list[i].p || 0) > 0) return true;
    return false;
  }

  /* Rule format: "recent:N" | "popular:N" | "cat:V" | "type:V" | "typestarts:V" */
  function ruleParts(rule) {
    var r = String(rule || ""), i = r.indexOf(":");
    return i > -1 ? { k: r.slice(0, i), v: r.slice(i + 1) } : { k: "", v: "" };
  }

  /* Trim to a limit. 0 or undefined means no limit. */
  function cut(arr, limit) {
    return limit > 0 ? arr.slice(0, limit) : arr;
  }

  function pick(rule, cap) {
    var p = ruleParts(rule), list = W.index, n = parseInt(p.v, 10);
    /* Tag and type rails are uncapped by default and show every match.
       railCap in the template config is a safety ceiling if a rail ever
       grows unwieldy. recent: and popular: always honour their own N. */
    var ceiling = cap || (W.railCap > 0 ? W.railCap : 0);

    if (p.k === "recent") return cut(byRecent(list), cap || n || 20);
    if (p.k === "popular") {
      /* No download data yet? Fall back to the Featured tag so the rail is
         never empty, rather than showing an arbitrary slice. */
      var src = hasPopularity(list)
        ? byPopular(list)
        : list.filter(function (it) { return inCat(it, "Featured"); });
      if (!src.length) src = byRecent(list);
      return cut(src, cap || n || 20);
    }
    /* Ordered newest-first before any trimming, so a rail shows the most
       recent entries carrying that tag rather than whatever order they
       happen to sit in inside the metafields. */
    if (p.k === "cat") return cut(byRecent(list.filter(function (it) { return inCat(it, p.v); })), ceiling);
    if (p.k === "type") return cut(byRecent(list.filter(function (it) { return String(it.t).toLowerCase() === p.v.toLowerCase(); })), ceiling);
    if (p.k === "typestarts") return cut(byRecent(list.filter(function (it) { return String(it.t).toLowerCase().indexOf(p.v.toLowerCase()) === 0; })), ceiling);
    return cut(byRecent(list), ceiling);
  }

  function inCat(it, cat) {
    var want = String(cat).toLowerCase();
    var list = it.c || [];
    for (var i = 0; i < list.length; i++) {
      if (String(list[i]).toLowerCase() === want) return true;
    }
    return false;
  }

  function railHTML(cat, id, items, rule) {
    return '<section class="wlv-sec" aria-labelledby="wlv-h-' + id + '"><div class="wlv-wrap">' +
        '<div class="wlv-sec-h">' +
          '<h2 id="wlv-h-' + id + '">' + esc(cat) + "</h2>" +
          '<button type="button" class="wlv-link" data-row-filter="' + esc(rule || ("cat:" + cat)) + '" data-row-title="' + esc(cat) + '">See all &rsaquo;</button>' +
        "</div>" +
        '<div class="wlv-rail-wrap">' +
          '<button type="button" class="wlv-rail-btn wlv-rail-btn--prev" aria-label="Scroll ' + esc(cat) + ' left">&lsaquo;</button>' +
          '<div class="wlv-rail" tabindex="0" role="group" aria-labelledby="wlv-h-' + id + '">' +
            items.map(cardHTML).join("") +
          "</div>" +
          '<button type="button" class="wlv-rail-btn wlv-rail-btn--next" aria-label="Scroll ' + esc(cat) + ' right">&rsaquo;</button>' +
        "</div>" +
      "</div></section>";
  }

  function buildRails() {
    var host = $("#wlv-rails");
    var feat = $("#wlv-feat-rail");

    if (feat) {
      /* The hero rail must never be empty. If nothing matches the rule, show
         the newest of everything rather than leaving a blank strip. The
         fallback honours the same limit so the rail keeps its shape. */
      var fLimit = Number(W.featuredLimit) > 0 ? Number(W.featuredLimit) : 5;
      var fRule = W.featuredRule || "typestarts:animation";
      var f = pick(fRule, fLimit);
      if (!f.length) {
        f = pick("recent:" + fLimit, fLimit);
        console.warn('[WLV] Nothing matched the featured rule "' + fRule +
          '". Falling back to newest.');
      }
      /* The ONLY rail that renders video. Wrapped rather than passed straight
         to map, which would hand cardHTML the array index as `withVideo`.
         To put video on every rail, add the same second argument to the
         cardHTML calls in railHTML() and call initVideos(host) below. */
      releaseVideos(feat);
      feat.innerHTML = f.map(function (it) { return cardHTML(it, true); }).join("");
      initVideos(feat);
    }

    if (host) {
      var out = "";
      (W.rows || []).forEach(function (row, n) {
        /* "Title|rule" */
        var bar = String(row).indexOf("|");
        var title = bar > -1 ? String(row).slice(0, bar) : String(row);
        var rule = bar > -1 ? String(row).slice(bar + 1) : "cat:" + title;
        var items = pick(rule);
        if (items.length) out += railHTML(title, "r" + n, items, rule);
      });
      host.innerHTML = out;
    }

    $$(".wlv-rail-wrap").forEach(wireRail);
  }

  function wireRail(wrap) {
    if (wrap.getAttribute("data-wired")) return;
    wrap.setAttribute("data-wired", "1");
    var rail = $(".wlv-rail", wrap),
        prev = $(".wlv-rail-btn--prev", wrap),
        next = $(".wlv-rail-btn--next", wrap);
    if (!rail || !prev || !next) return;
    function upd() {
      var max = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
    }
    function go(dir) {
      rail.scrollBy({ left: dir * Math.round(rail.clientWidth * 0.85), behavior: motion() });
    }
    prev.addEventListener("click", function () { go(-1); });
    next.addEventListener("click", function () { go(1); });
    rail.addEventListener("scroll", upd, { passive: true });
    window.addEventListener("resize", upd, { passive: true });
    upd();
  }
  /* Deliberately NOT wired at module load. Every rail is built by
     buildRails() once the index arrives, so wiring here would only mark the
     still-empty featured wrapper as done and freeze its arrows disabled. */

  /* ------------------------------------------------------------------ *
   * 10. Video previews — in view only, never more than two at once
   *
   * This used to be an IIFE that ran at module load. Nothing was on the page
   * at that point — every card is written by buildRails() once the async index
   * lands — so it matched zero elements and had never registered a video in
   * production. It is now a function the render paths call on the subtree they
   * just wrote. Registration is idempotent via data-vid-init, so re-rendering
   * a rail cannot stack two observers on the same element.
   * ------------------------------------------------------------------ */
  var VID_SEL = ".wlv-thumb video, .wlv-m-media video";

  /* Ceiling on simultaneous playback. It must be at least as large as the
     number of tiles one rail can show at once, or tiles that are plainly on
     screen sit frozen. The featured rail is the only rail with video and its
     length is config, so the cap follows it — bounded at 6, which is about as
     many 3:4 cards as fit across a wide desktop rail. */
  var VID_MAX = Math.min(6, Math.max(2, Number(W.featuredLimit) || 5));

  /* Two lists, not one. `visible` is what the observer says is on screen;
     `playing` is what is actually decoding. Keeping them apart is what lets a
     tile that lost its slot start again later — the old single-list version
     evicted the oldest tile on sight, and since IntersectionObserver only
     reports CHANGES, a tile paused while still fully visible was never
     revisited and stayed frozen for the life of the page. */
  var vidVisible = [], playing = [], vidIO = null;

  /* True while a modal is open. The rails are behind a full-screen overlay
     then, so nothing there should be decoding. */
  var vidHold = false;
  function isModalVid(v) { return !!(v.closest && v.closest(".wlv-m-media")); }

  /* Single place that decides what plays. Called whenever visibility, modal
     state or the set of registered videos changes. */
  function pumpVideos() {
    var i, v, p;
    for (i = playing.length - 1; i >= 0; i--) {
      v = playing[i];
      if (vidVisible.indexOf(v) === -1 || (vidHold && !isModalVid(v))) {
        if (!v.paused) v.pause();
        playing.splice(i, 1);
      }
    }
    for (i = 0; i < vidVisible.length && playing.length < VID_MAX; i++) {
      v = vidVisible[i];
      if (playing.indexOf(v) > -1) continue;
      if (vidHold && !isModalVid(v)) continue;
      p = v.play();
      if (p && p.catch) p.catch(function () {});
      playing.push(v);
    }
  }

  /* Drop a video from both lists — used on error and before its node is
     discarded — then let the pump hand its slot to something still on screen. */
  function forgetVid(v) {
    var a = vidVisible.indexOf(v); if (a > -1) vidVisible.splice(a, 1);
    var b = playing.indexOf(v);    if (b > -1) playing.splice(b, 1);
    if (!v.paused) v.pause();
  }

  /* Register every not-yet-registered preview inside `scope`. */
  function initVideos(scope) {
    if (liteMedia() || typeof window.IntersectionObserver !== "function") return;
    if (!vidIO) {
      vidIO = new window.IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var i = vidVisible.indexOf(e.target);
          if (e.isIntersecting) { if (i === -1) vidVisible.push(e.target); }
          else if (i > -1) vidVisible.splice(i, 1);
        });
        pumpVideos();
      }, { rootMargin: "150px 100px", threshold: 0.25 });
    }
    $$(VID_SEL, scope || document).forEach(function (v) {
      if (v.getAttribute("data-vid-init")) return;
      v.setAttribute("data-vid-init", "1");
      /* Set as properties as well as attributes: iOS only honours inline
         autoplay when the element is genuinely muted and playsinline. */
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute("playsinline", ""); v.setAttribute("webkit-playsinline", "");
      v.addEventListener("playing", function () { v.classList.add("is-on"); });
      /* Failure must reveal the poster underneath, never a black panel. */
      v.addEventListener("error", function () { v.classList.remove("is-on"); forgetVid(v); pumpVideos(); });
      vidIO.observe(v);
    });
  }

  /* Pause and unobserve previews in `scope` before their nodes are replaced,
     so detached elements cannot hold a playback slot or an observer entry. */
  function releaseVideos(scope) {
    $$(VID_SEL, scope || document).forEach(function (v) {
      forgetVid(v);
      if (vidIO) vidIO.unobserve(v);
    });
    pumpVideos();
  }

  /* ------------------------------------------------------------------ *
   * 11. Taxonomy, derived from the index so it can never drift
   * ------------------------------------------------------------------ */
  function uniq(fn) {
    var seen = {}, out = [];
    W.index.forEach(function (it) {
      var v = fn(it);
      (Array.isArray(v) ? v : [v]).forEach(function (x) {
        if (x && !seen[x]) { seen[x] = 1; out.push(x); }
      });
    });
    return out.sort();
  }
  var SERIES = [], CHARS = [], OUTFITS = [], TYPES = [];
  function buildTaxonomy() {
    SERIES = uniq(function (i) { return i.a; });
    CHARS = uniq(function (i) { return i.n; });
    OUTFITS = uniq(function (i) { return i.o; });
    /* Types come from the template config, not the loaded index, so the chips
       are complete before the index finishes arriving. */
    TYPES = (W.types && W.types.length) ? W.types.slice() : uniq(function (i) { return i.t; });
  }
  buildTaxonomy();

  function fillSelect(el, label, vals, cur) {
    if (!el) return;
    el.innerHTML = '<option value="">' + label + "</option>" + vals.map(function (v) {
      return '<option value="' + esc(v) + '"' + (v === cur ? " selected" : "") + ">" + esc(v) + "</option>";
    }).join("");
  }
  function syncSelects() {
    fillSelect($("#wlv-f-series"), "All series", SERIES, S.series);
    fillSelect($("#wlv-d-series"), "All series", SERIES, S.series);
    fillSelect($("#wlv-f-char"), "All characters", CHARS, S.chr);
    fillSelect($("#wlv-d-char"), "All characters", CHARS, S.chr);
    fillSelect($("#wlv-f-outfit"), "All outfits", OUTFITS, S.outfit);
    fillSelect($("#wlv-d-outfit"), "All outfits", OUTFITS, S.outfit);
  }
  function syncChips() {
    $("#wlv-chips").innerHTML =
      '<button type="button" class="wlv-chip" data-type="" aria-pressed="' + (S.type === "") + '">All types</button>' +
      TYPES.map(function (t) {
        return '<button type="button" class="wlv-chip" data-type="' + esc(t) + '" aria-pressed="' + (S.type === t) + '">' + esc(label(t)) + "</button>";
      }).join("");
  }

  function afterChange() {
    S.page = 1;
    syncSelects();
    setView("browse");
    renderResults();
  }
  function resetAll() {
    S.q = ""; S.type = ""; S.series = ""; S.chr = ""; S.outfit = ""; S.row = ""; S.rowFilter = ""; S.sort = "new"; S.page = 1;
    $("#wlv-q").value = "";
    $("#wlv-q-clear").hidden = true;
    syncChips(); syncSelects(); setView("browse");
    window.scrollTo({ top: 0, behavior: motion() });
  }

  /* ------------------------------------------------------------------ *
   * 12. Delegated events
   * ------------------------------------------------------------------ */
  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest(
      "[data-open],[data-dl],[data-join],[data-clear],[data-reset],[data-row-filter],[data-view],[data-goto],[data-paused],[data-tab]"
    );
    if (!t || !root.contains(t)) return;

    if (t.hasAttribute("data-open")) { openItem(t.getAttribute("data-open")); return; }
    if (t.hasAttribute("data-dl")) { download(t.getAttribute("data-dl")); return; }
    if (t.hasAttribute("data-paused")) { toast("Membership on hold. Downloads come back when billing resumes."); return; }
    if (t.hasAttribute("data-join")) { closeModal(); join(); return; }

    if (t.hasAttribute("data-clear")) {
      var k = t.getAttribute("data-clear");
      if (k === "q") { S.q = ""; $("#wlv-q").value = ""; $("#wlv-q-clear").hidden = true; }
      else if (k === "type") { S.type = ""; syncChips(); }
      else if (k === "series") S.series = "";
      else if (k === "chr") S.chr = "";
      else if (k === "outfit") S.outfit = "";
      else if (k === "row") { S.row = ""; S.rowFilter = ""; }
      afterChange();
      return;
    }

    if (t.hasAttribute("data-reset")) { resetAll(); return; }

    if (t.hasAttribute("data-row-filter")) {
      var rf = t.getAttribute("data-row-filter") || "";
      if (rf.indexOf(":") === -1) return;   /* no usable filter, do nothing */
      S.rowFilter = rf;
      S.row = t.getAttribute("data-row-title") || "";
      S.q = ""; $("#wlv-q").value = ""; $("#wlv-q-clear").hidden = true;
      S.type = ""; S.series = ""; S.chr = ""; S.outfit = "";
      syncChips(); afterChange();
      track("row_expand", { row: S.row });
      window.scrollTo({ top: Math.max(0, $(".wlv-tools").offsetTop - 10), behavior: motion() });
      return;
    }

    if (t.hasAttribute("data-view")) {
      var v = t.getAttribute("data-view");
      /* Browse is a "take me home" action. Without clearing state it would
         leave the visitor stuck on the results view, because setView keeps
         results showing whenever a search or filter is active. */
      if (v === "browse") { resetAll(); return; }
      setView(v);
      window.scrollTo({ top: 0, behavior: motion() });
      return;
    }

    if (t.hasAttribute("data-tab")) {
      $("#wlv-q").focus();
      window.scrollTo({ top: Math.max(0, $(".wlv-tools").offsetTop - 10), behavior: motion() });
      return;
    }

    if (t.hasAttribute("data-goto")) {
      var id = t.getAttribute("data-goto");
      setView("browse");
      setTimeout(function () {
        var el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: motion(), block: "start" });
      }, 30);
      return;
    }
  });

  /* ---- search input, debounced ---- */
  var deb;
  $("#wlv-q").addEventListener("input", function () {
    var v = this.value;
    $("#wlv-q-clear").hidden = v === "";
    clearTimeout(deb);
    deb = setTimeout(function () {
      S.row = ""; S.rowFilter = ""; S.q = v.trim(); S.page = 1;
      setView("browse"); renderResults();
      if (S.q) track("search", { term: S.q, results: filtered().length });
    }, 180);
  });
  $("#wlv-q-clear").addEventListener("click", function () {
    S.q = ""; $("#wlv-q").value = ""; this.hidden = true;
    $("#wlv-q").focus(); afterChange();
  });
  $("#wlv-more").addEventListener("click", function () { S.page++; renderResults(); });

  /* ---- filter controls ---- */
  function bind(sel, key) {
    var el = $(sel);
    if (!el) return;
    el.addEventListener("change", function () { S[key] = this.value; S.row = ""; S.rowFilter = ""; afterChange(); });
  }
  bind("#wlv-f-series", "series"); bind("#wlv-d-series", "series");
  bind("#wlv-f-char", "chr");      bind("#wlv-d-char", "chr");
  bind("#wlv-f-outfit", "outfit"); bind("#wlv-d-outfit", "outfit");
  /* Sort control removed from the UI. S.sort stays "new" for the lifetime of
     the page, so filtered() always orders newest-first. The ordering code in
     filtered() and byRecent() is untouched. */

  $("#wlv-chips").addEventListener("click", function (e) {
    var b = e.target.closest("[data-type]");
    if (!b) return;
    S.type = b.getAttribute("data-type"); S.row = ""; S.rowFilter = "";
    syncChips(); afterChange();
    track("filter", { type: S.type });
  });

  $("#wlv-filters-btn").addEventListener("click", function () { openModal($("#wlv-drawer")); });
  $("#wlv-d-apply").addEventListener("click", function () { closeModal(); afterChange(); });
  $("#wlv-d-reset").addEventListener("click", function () { closeModal(); resetAll(); });
  $("#wlv-drawer").addEventListener("click", function (e) { if (e.target === this) closeModal(); });
  $("#wlv-m-close").addEventListener("click", closeModal);
  $("#wlv-item-modal").addEventListener("click", function (e) { if (e.target === this) closeModal(); });

  /* ---- plan selector ---- */
  /* Annual was dropped before launch: at 12 x the monthly price it offered
     nothing over monthly once credits went away. The markup no longer renders
     a plan chooser, so this only runs if one is reintroduced. PLAN stays
     "monthly", which is the single key on W.plans. */
  $$(".wlv-planopt").forEach(function (lab) {
    var input = lab.querySelector("input");
    if (!input) return;
    input.addEventListener("change", function () {
      PLAN = lab.getAttribute("data-plan") || "monthly";
      $$(".wlv-planopt").forEach(function (l) { l.classList.toggle("is-on", l === lab); });
      $("#wlv-plan-amt").textContent = W.price.monthly;
      $("#wlv-plan-per").textContent = "/month + tax";
      $("#wlv-plan-note").textContent = "Billed monthly. Cancel anytime.";
      var cta = $("#wlv-plan-cta");
      if (cta) cta.textContent = "Start monthly membership";
    });
  });

  /* ---- sticky CTA dismiss ---- */
  var ctaX = $("#wlv-cta-x");
  if (ctaX) ctaX.addEventListener("click", function () { root.classList.add("wlv-cta-off"); });

  /* ---- age gate ---- */
  (function ageGate() {
    var ok = false;
    try { ok = localStorage.getItem("wlv_age") && Date.now() < +localStorage.getItem("wlv_age"); } catch (e) {}
    if (!ok) {
      var g = $("#wlv-age");
      g.hidden = false; openEl = g;
      document.body.style.overflow = "hidden";
      setTimeout(function () { $("#wlv-age-yes").focus(); }, 50);
    }
    $("#wlv-age-yes").addEventListener("click", function () {
      try { localStorage.setItem("wlv_age", String(Date.now() + 30 * 864e5)); } catch (e) {}
      closeModal();
    });
    $("#wlv-age-no").addEventListener("click", function () { window.location.href = "https://www.google.com"; });
  })();

  /* ------------------------------------------------------------------ *
   * 13. Boot
   * ------------------------------------------------------------------ */
  var count = (W.indexed || W.index.length).toLocaleString();
  $$("[data-count-slot]").forEach(function (el) { el.textContent = count; });

  syncChips();
  syncSelects();
  setView("browse");

  /* ------------------------------------------------------------------ *
   * 14. Async index
   * The page paints from the server-rendered rails. The index arrives a
   * moment later from the page.wlv-idxN templates, fetched in parallel.
   * Splitting it is what keeps each request inside Shopify's Liquid budget.
   * ------------------------------------------------------------------ */
  var qInput = $("#wlv-q");

  function setSearchBusy(busy) {
    if (!qInput) return;
    qInput.disabled = busy;
    qInput.placeholder = busy
      ? "Loading the vault\u2026"
      : "Search character, series or outfit";
  }

  function onIndexReady() {
    RECENCY_KEY = null;
    buildTaxonomy();
    buildRails();
    syncSelects();
    syncChips();
    var n = W.index.length;
    W.indexed = n;
    $$("[data-count-slot]").forEach(function (el) { el.textContent = n.toLocaleString(); });
    setSearchBusy(false);
    if (!$("#wlv-results").hidden) renderResults();
    if (!n) {
      console.warn("[WLV] Index is empty. Check that the page.wlv-idx templates exist and that ?view=wlv-idx1 returns JSON.");
      var tools = document.querySelector(".wlv-tools");
      if (tools) tools.hidden = true;
      var host2 = $("#wlv-rails");
      if (host2) {
        host2.innerHTML =
          '<section class="wlv-sec"><div class="wlv-wrap"><div class="wlv-empty">' +
          '<p style="font-weight:700;color:#fff;margin-bottom:6px">The vault could not load.</p>' +
          "<p>Check your connection and try again.</p>" +
          '<p style="margin-top:14px"><button type="button" class="wlv-btn wlv-btn--sm wlv-btn--ghost" id="wlv-retry">Try again</button></p>' +
          '<p class="wlv-mut" style="margin-top:14px;font-size:12px">Tried: ' + esc(urlFor(W.indexPageView || "wlv-index", 1)) + "</p>" +
          "</div></div></section>";
        var rb = document.getElementById("wlv-retry");
        if (rb) rb.addEventListener("click", function () { rb.disabled = true; loadIndex(); });
      }
    }
  }

  /* Build the slice URL from the CURRENT path so market and locale prefixes
     survive, and carry preview_theme_id so a draft theme fetches its own
     templates rather than the published ones. */
  function urlFor(view, page) {
    var url = window.location.pathname + "?view=" + encodeURIComponent(view);
    if (page) url += "&page=" + page;
    try {
      var pid = new URL(window.location.href).searchParams.get("preview_theme_id");
      if (pid) url += "&preview_theme_id=" + encodeURIComponent(pid);
    } catch (e) {}
    return url;
  }

  /* ---- cache -------------------------------------------------------- *
   * 77 requests is a lot to repeat on every visit, so the assembled index
   * is kept in localStorage for a few hours. Keyed by membership state so a
   * guest never reads a member's cached copy. Refreshed in the background
   * once the cached copy has been rendered. */
  var CACHE_KEY = "wlv_idx_" + (W.state || "guest");
  /* Bump this whenever the index shape or its source changes. Version 3 was
   written by the paginate build and could contain as few as 20 items, which
   then stuck for six hours. Bumping discards those on sight. Version 6 adds
   the "v" preview-video key — without the bump, anyone holding a v5 cache
   would get image-only featured cards for up to six hours after release. */
  var CACHE_VERSION = 6;
  var CACHE_TTL = 6 * 60 * 60 * 1000;

  function readCache() {
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
      if (!c || c.v !== CACHE_VERSION) return null;
      if (Date.now() - c.t > CACHE_TTL) return null;
      if (!c.d || !c.d.length) return null;
      return c.d;
    } catch (e) { return null; }
  }
  function writeCache(items) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ v: CACHE_VERSION, t: Date.now(), d: items }));
    } catch (e) { /* quota — not fatal, just means no cache next time */ }
  }

  var seenIds = {};
  /* Target-aware on purpose: a background refresh accumulates into a scratch
     array so the copy currently on screen is never emptied mid-flight. */
  function mergeInto(target, seen, items) {
    if (!items) return;
    for (var k = 0; k < items.length; k++) {
      var it = items[k];
      if (it && it.i && !seen[it.i]) { seen[it.i] = 1; target.push(it); }
    }
  }

  function progress(done, total) {
    var host = $("#wlv-rails");
    if (!host) return;
    var pct = total ? Math.round((done / total) * 100) : 0;
    host.innerHTML =
      '<section class="wlv-sec"><div class="wlv-wrap">' +
      '<p class="wlv-mut" style="text-align:center;padding:30px 0">Loading the vault\u2026 ' + pct + "%</p>" +
      "</div></section>";
  }

  /* ---- paginated loader --------------------------------------------- *
   * A {% for %} over shop.metaobjects caps at 50 entries and ignores
   * offset. {% paginate %} does not, but forces 20 per page — so the whole
   * library is walked page by page, a few at a time. */
  function loadPaginated(target, seen, onDone, onFail) {
    var view = W.indexPageView;
    if (!view) { onFail(); return; }   /* paginate path switched off in config */
    var CONCURRENCY = 6;

    fetch(urlFor(view, 1), { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); })
      .then(function (txt) {
        var first;
        try {
          first = JSON.parse(String(txt).trim());
        } catch (e) {
          throw new Error("page 1 did not return JSON. First 200 chars: " + String(txt).trim().slice(0, 200));
        }
        if (!first || !first.items) throw new Error("page 1 returned no items key");

        mergeInto(target, seen, first.items);
        var pages = first.pages || 1, done = 1;
        var claimedTotal = first.total || 0;
        progress(done, pages);
        if (pages < 2) {
          if (claimedTotal && target.length < claimedTotal * 0.5) { target.length = 0; onFail(); return; }
          onDone();
          return;
        }

        var next = 2, active = 0, failed = 0;

        function pump() {
          while (active < CONCURRENCY && next <= pages) {
            active++;
            (function (pageNo) {
              fetch(urlFor(view, pageNo), { credentials: "same-origin" })
                .then(function (r) { return r.ok ? r.text() : null; })
                .then(function (t) {
                  if (t === null) { failed++; return; }
                  try { mergeInto(target, seen, JSON.parse(String(t).trim()).items); }
                  catch (e) { failed++; }
                })
                .catch(function () { failed++; })
                .then(function () {
                  active--; done++;
                  progress(done, pages);
                  if (next <= pages) { pump(); return; }
                  if (active === 0) {
                    if (failed) console.warn("[WLV] " + failed + " of " + pages + " index pages failed.");
                    /* Sanity check. Some storefronts ignore ?page= on a page
                       template and serve page 1 for every request, so all the
                       extra fetches dedupe down to nothing. That is a silent
                       success with a fraction of the library, which is worse
                       than an outright failure — so treat it as one. */
                    if (claimedTotal && target.length < claimedTotal * 0.5) {
                      console.warn("[WLV] Paginated index returned only " + target.length +
                        " of a claimed " + claimedTotal + " items. ?page= appears to be ignored. " +
                        "Falling back to the chunk slices.");
                      target.length = 0;
                      for (var kk in seen) delete seen[kk];
                      onFail();
                      return;
                    }
                    onDone();
                  }
                });
            })(next++);
          }
        }
        pump();
      })
      .catch(function (e) {
        console.warn("[WLV] Paginated index unavailable (" + e.message + "). Falling back to the chunk slices.");
        onFail();
      });
  }

  /* ---- fallback: the original four chunk slices ---------------------- */
  function loadSlices(target, seen, onDone) {
    var views = (W.indexViews || []).filter(Boolean);
    if (!views.length) { onDone(); return; }
    var pending = views.length;
    views.forEach(function (v) {
      fetch(urlFor(v), { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) {
          if (t === null) return;
          try { mergeInto(target, seen, JSON.parse(String(t).trim()).items); } catch (e) {}
        })
        .catch(function () {})
        .then(function () { if (--pending === 0) onDone(); });
    });
  }

  function loadIndex() {
    if (typeof window.fetch !== "function") { onIndexReady(); return; }

    var cached = readCache();

    if (cached) {
      /* Render immediately from cache, then refresh into a scratch array and
         only swap if the library actually changed. W.index stays populated
         the entire time, so search and downloads never go dead. */
      W.index = cached;
      seenIds = {};
      cached.forEach(function (it) { seenIds[it.i] = 1; });
      onIndexReady();
      console.info("[WLV] " + cached.length + " items from cache. Refreshing in the background.");

      var scratch = [], scratchSeen = {};
      loadPaginated(scratch, scratchSeen,
        function () {
          if (!scratch.length) return;
          writeCache(scratch);
          if (scratch.length !== cached.length) {
            W.index = scratch;
            seenIds = scratchSeen;
            console.info("[WLV] Library changed: " + cached.length + " -> " + scratch.length + ". Re-rendering.");
            onIndexReady();
          }
        },
        function () {
          /* Paginate is off or failed. Refresh from the chunk slices instead,
             otherwise a small or stale cache would persist for hours. */
          loadSlices(scratch, scratchSeen, function () {
            if (!scratch.length) return;
            writeCache(scratch);
            if (scratch.length !== cached.length) {
              W.index = scratch;
              seenIds = scratchSeen;
              console.info("[WLV] Library changed: " + cached.length + " -> " + scratch.length + ". Re-rendering.");
              onIndexReady();
            }
          });
        }
      );
      return;
    }

    setSearchBusy(true);
    progress(0, 1);
    loadPaginated(W.index, seenIds,
      function () { writeCache(W.index); onIndexReady(); },
      function () {
        loadSlices(W.index, seenIds, function () {
          /* Cache the slice result too, otherwise every visit re-fetches. */
          if (W.index.length) writeCache(W.index);
          onIndexReady();
        });
      }
    );
  }

  /* ------------------------------------------------------------------ *
   * Direct join link: /pages/waifu-lewd-vault?join=1
   *
   * This is THE link to put in ads, emails and DMs. Do NOT use a cart
   * permalink (/cart/VARIANT:1?selling_plan=...) for the membership:
   * verified 27 Aug 2026 that the Shop Pay redirect drops the selling plan
   * from permalinks and checks the customer out with a one-time $12.99
   * purchase. No subscription is created, so the Grant Access flow never
   * fires, the customer never gets the WLV Subscriber tag, and they are
   * locked out of the vault they just paid for (order #1032945 x3 is this
   * exact failure). The cart route below keeps the plan: the same Shop Pay
   * checkout then reads "automatically renewing subscription".
   *
   * Guests are sent to log in first, and the join intent survives the round
   * trip through return_to, so one tap after login lands in checkout.
   * ------------------------------------------------------------------ */
  if (/[?&]join=1(?:&|$)/.test(location.search)) {
    if (W.state === "guest") {
      window.location.href = "/customer_authentication/login?return_to=" +
        encodeURIComponent("/pages/waifu-lewd-vault?join=1");
    } else if (W.state !== "member") {
      join();
    }
  }

  /* Kick off once the browser is idle so it never competes with first paint. */
  if (window.requestIdleCallback) requestIdleCallback(loadIndex, { timeout: 1500 });
  else setTimeout(loadIndex, 200);

  if (!W.index.length) {
    console.warn("[WLV] Search index is empty. Check the vault_index_* metafield handles in the template config.");
  }
})();